import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ServifinPdfService } from '../../../services/operaciones/servifin-pdf/servifin-pdf.service';
import { ServifinCreditoService } from '../../../services/operaciones/servifin-credito/servifin-credito.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-cotizador-credito-servifin',
  templateUrl: './cotizador-credito-servifin.component.html',
  styleUrls: ['./cotizador-credito-servifin.component.scss']
})
export class CotizadorCreditoServifinComponent {
  loading = false;
  cotizacion: any = null;
  form = new FormGroup({
    Cliente: new FormControl('', Validators.required),
    Num_Doc_Cliente: new FormControl(''),
    No_Poliza: new FormControl(''),
    Corredor: new FormControl(''),
    Aseguradora: new FormControl(''),
    Valor_Prima: new FormControl(12275281, [Validators.required, Validators.min(1)]),
    Cuota_Inicial: new FormControl(0),
    Tasa_Negociacion: new FormControl(2.15, Validators.required),
    Plazo: new FormControl(4, [Validators.required, Validators.min(1)]),
    Fecha_Inicio: new FormControl(new Date().toISOString().substring(0, 10)),
    Gastos_Papeleria_Cuota: new FormControl(0),
    Vr_Admon_Cuota: new FormControl(0),
    Fecha_Corte: new FormControl(new Date().toISOString().substring(0, 10)),
    Numero_Credito: new FormControl('COP-1-9189'),
  });

  reportes = [
    { id: 'tabla_amortizacion', label: 'Tabla amortización' },
    { id: 'estado_cuenta', label: 'Estado de cuenta' },
    { id: 'operacion_vigente', label: 'Operación vigente' },
    { id: 'liquidacion_credito', label: 'Liquidación crédito' },
    { id: 'recibo_caja', label: 'Recibo de caja' },
    { id: 'factura_intereses', label: 'Factura intereses' },
  ];

  servifinMode = environment.SERVIFIN_MODE;

  constructor(
    private servifinCreditoService: ServifinCreditoService,
    private servifinPdfService: ServifinPdfService
  ) {}

  calcular() {
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    this.servifinCreditoService.calcular(this.form.getRawValue()).subscribe(
      res => {
        this.cotizacion = res['data'] || res;
        this.loading = false;
      },
      () => { this.loading = false; }
    );
  }

  exportarPdf(tipo: string) {
    if (!this.cotizacion) {
      this.calcular();
      return;
    }
    const payload = Object.assign({}, this.cotizacion, this.form.getRawValue());
    if (tipo === 'liquidacion_credito') {
      payload.Fecha_Corte = this.form.controls['Fecha_Corte'].value;
    }
    if (tipo === 'recibo_caja' || tipo === 'factura_intereses') {
      payload.Cuota_Pago = (this.cotizacion.Cuotas || [])[0];
      payload.Pago = {
        Total_Pagado: payload.Cuota_Pago ? payload.Cuota_Pago.Total_Cuota : 0,
        Fecha_Recaudo: new Date().toISOString().substring(0, 10),
        Concepto: 'RECAUDO PAGO RECIBIDO',
      };
    }
    this.servifinPdfService.generarPdf(payload, tipo).subscribe(blob => {
      this.servifinPdfService.descargarBlob(blob, `Servifin_${tipo}.pdf`);
    });
  }
}
